import React from 'react';
import { Spin } from 'antd';

const FullPageLoading = () => (
  <div className="fullscreen">
    <Spin size="large" />
  </div>
);

export default FullPageLoading;
